/**
 * @ngdoc Service
 */
(function() {
    'use strict';

    angular.module('vrm.components')
        .service('VrmBufferedMQTTService', VrmBufferedMQTTService);


    /* @ngInject */
    function VrmBufferedMQTTService() {

        var service = {
            createBufferFactory: createBufferFactory
        };
    
        function createBufferFactory(scope, throttleInterval=250) {
            // Map for holding most recent mqtt messages
            var defferredFunctions = {};

            return {
                processCacheThrottled: _.throttle(function() {
                    // not using evalAsync can lead to digest cycle conflicts
                    scope.$evalAsync(function() {
                        Object.entries(defferredFunctions).forEach(([path, func]) => {
                            if (func !== undefined) {
                                func();
                                if (func === defferredFunctions[path]) {
                                    delete defferredFunctions[path];
                                }
                            }
                        });
                    })
                }, throttleInterval),
                addToFunctionCache: function(func, subscriptionPath) {
                    defferredFunctions[subscriptionPath] = func;
                    this.processCacheThrottled();
                }
            }
        }
        return service;
    }
})();
